import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { GREAT_WHITE, KOALA, OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';
import { useIsActiveRoute } from '../../../hooks/useIsActiveRoute';
import { getIsAdminPreview } from '../../../selectors/app';

const makeEmbeddedStyledNavButton = ButtonComponent => styled(ButtonComponent).attrs(() => ({
  use: 'transparent'
})).withConfig({
  displayName: "RouterNavButton__makeEmbeddedStyledNavButton",
  componentId: "sc-1u44aa8-0"
})(["&&{background-color:", ";border:0;color:", ";font-size:16px;font-weight:", ";&:hover{background-color:", ";color:", ";text-decoration:none;}}"], props => props.active ? KOALA : 'transparent', OBSIDIAN, WEB_FONT_DEMI_BOLD_WEIGHT, GREAT_WHITE, OBSIDIAN);

const makeStyledNavButton = ButtonComponent => styled(ButtonComponent).attrs(() => ({
  use: 'transparent'
})).withConfig({
  displayName: "RouterNavButton__makeStyledNavButton",
  componentId: "sc-1u44aa8-1"
})(["&&{text-decoration:", ";border:0;color:", ";font-size:16px;font-weight:", ";&:hover{color:", ";text-decoration:'underline';}}"], props => props.active ? 'underline' : 'none', OLAF, WEB_FONT_DEMI_BOLD_WEIGHT, OLAF);

const StyledNavButton = makeStyledNavButton(UIButton);
const StyledRouterNavButton = makeStyledNavButton(UIRouterNavButton);
const EmbeddedStyledRouterNavButton = makeEmbeddedStyledNavButton(UIRouterNavButton);
export default function RouterNavButton(_ref) {
  let {
    active,
    isEmbedded = false,
    to,
    exact = false,
    matchEscape
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["active", "isEmbedded", "to", "exact", "matchEscape"]);

  const isActiveRoute = useIsActiveRoute(to, exact, matchEscape);
  const isAdminPreview = useSelector(getIsAdminPreview);
  const RouterButton = isEmbedded ? EmbeddedStyledRouterNavButton : StyledRouterNavButton;
  return /*#__PURE__*/_jsx(RouterButton, Object.assign({}, rest, {
    active: active || isActiveRoute,
    exact: exact,
    onClick: evt => {
      if (isAdminPreview) {
        evt.preventDefault();
      }
    },
    to: to
  }));
}
export function DropdownButton(props) {
  return /*#__PURE__*/_jsx(EmbeddedStyledRouterNavButton, Object.assign({}, props));
}
export function ActiveDropdownButton(props) {
  return /*#__PURE__*/_jsx(EmbeddedStyledRouterNavButton, Object.assign({}, props, {
    active: true
  }));
}